module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ui-auth', {
    key: "changePassword",
    attrs: {
      "id": "changePassword",
      "success": _vm.onSuccess,
      "fail": _vm.onFail
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-597b8754"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/auth/Change.vue
// module id = 496
// module chunks = 0